import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/awesome-design-system-100/awesome-design-system-100/node_modules/@bridgetool/gatsby-theme-dev/src/components/ThemeComponents/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This section is meant to describe the components of your library (or libraries).`}</p>
    <p>{`Create a separate page for each component or a group of components, and list the pages in the side menu.`}</p>
    <h2>{`Page structure`}</h2>
    <p>{`Each design system has its own structure for the component pages. You should find your own which meets the needs
of designers and developers using this documentation.`}</p>
    <p>{`However, you can follow the general guidelines, like the following.`}</p>
    <ul>
      <li parentName="ul">{`Explain the purpose of the component`}</li>
      <li parentName="ul">{`Describe when it should be used`}</li>
      <li parentName="ul">{`Demonstrate the use cases with "do and don't" blocks`}</li>
      <li parentName="ul">{`Provide live examples`}</li>
      <li parentName="ul">{`Give code samples`}</li>
    </ul>
    <h2>{`Documenting features`}</h2>
    <h3>{`Code examples`}</h3>
    <p>{`Provide code examples.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<AwesomeButton type="primary">Primary</AwesomeButton>
`}</code></pre>
    <h3>{`Live code examples`}</h3>
    <p>{`Code examples can render live.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<AwesomeButton type="primary">Primary</AwesomeButton>
`}</code></pre>
    <h3>{`Dos and donts`}</h3>
    <p>{`Use "Do and dont" block to explain how to use the component.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    Use brief and <b>direct communication</b>
  </Do>
  <Dont mdxType="Dont">
    Don't use wordy and redundant copy
  </Dont>
    </DoDontContainer>
    <pre><code parentName="pre" {...{}}>{`<DoDontContainer>
  <Do>
    Use brief and <b>direct communication</b>
  </Do>
  <Dont>
    Don't use wordy and redundant copy
  </Dont>
</DoDontContainer>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      